import styled from 'styled-components';

import { viewSizes } from '../../theme/sizes';

export const ModalContents = styled.div<{ width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string }>`
  width: ${({ width }) => viewSizes[(width || 'sm') as keyof typeof viewSizes] ?? width};

  max-height: 80vh;

  input {
    margin-bottom: 1em;
  }

  .pull-left {
    float: left;
  }

  button[type='submit'] {
    margin-right: 1em;
  }
`;
